import { TRootState } from '#/redux/store';

const key = '__persisted_state__';

export const loadPersistedStore = () => {
  try {
    const serializedState = localStorage.getItem(key);
    if (serializedState === null) {
      return;
    }
    return JSON.parse(serializedState);
  } catch {
    return;
  }
};

export const persistStore = (state: Partial<TRootState>) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(key, serializedState);
  } catch {
    // TODO: handle error, cant store in localstorage
  }
};
